import Vue from "vue";
import {
  Button,
  Cell,
  Header,
  Swipe,
  SwipeItem,
  Toast,
  Navbar,
  TabItem,
  TabContainer,
  TabContainerItem,
  MessageBox,
  Popup
} from "mint-ui";
import { Field } from "mint-ui";
import { Picker } from "mint-ui";
import { Loadmore } from "mint-ui";

Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
Vue.component(Header.name, Header);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(MessageBox.name, MessageBox);
Vue.component(Field.name, Field);
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);
Vue.component(Loadmore.name, Loadmore);

Vue.prototype.Toast = Toast;
